const data = [{
        "content": "National Science Fund for Distinguished Young Scholars (62325208): Highly Reliable Industrial Internet of Things, 2024-2028.",
        "id": 1,
        "language": "英语"
    },
    {
        "content": "National Natural Science Foundation of China (U2001204): Research on Key Technologies of Efficient and Secure Mobile Internet of Things for 5G and Future Networks, 2021-2023.",
        "id": 2,
        "language": "英语"
    },
    {
        "content": "National Natural Science Foundation of China (62272339): Research on Robustness of Intelligent Sensing and Behavior Recognition for Wireless Channel State Information, 2023-2026.",
        "id": 3,
        "language": "英语"
    },
    {
        "content": "National Natural Science Foundation of China (61672131):  Research on Robustness and Modeling for Large-Scale Heterogeneous Sensor Networks in Interent of Things, 2017-2020.",
        "id": 4,
        "language": "英语"
    },
    {
        "content": "2021 Industrial Internet Innovation and Development Project - Time-sensitive Network Control System, 2021-2023.",
        "id": 5,
        "language": "英语"
    },
    {
        "content": "<p><strong>[1] </strong><strong style=\"color: rgb(112, 48, 160);\"><em>国家杰出青年科学基金</em></strong><span style=\"color: black;\">（62325208）：高可靠工业物联网，2024-2028，400万元</span>，<strong><u>负责人</u></strong>。",
        "id": 7,
        "language": "汉语"
    },
    {
        "content": "<strong>[2] </strong><strong style=\"color: rgb(112, 48, 160);\"><em>国家重点研发计划课题</em></strong> （2019YFB1703600）<span style=\"color: black;\">：柔性系统非确定性制造大数据理论与方法研究，</span>2020-2022，总经费452万元（课题91万元），<strong><u>课题负责人</u></strong>。",
        "id": 8,
        "language": "汉语"
    },
    {
        "content": "<strong>[3] </strong><strong style=\"color: rgb(112, 48, 160);\"><em>国家自然科学基金联合重点项目</em></strong><span style=\"color: black;\"> （U2001204）：面向5G及未来网络的高效安全移动物联网关键技术研究2021-2023，260万元</span>，<strong><u>负责人</u></strong>。",
        "id": 9,
        "language": "汉语"
    },
    {
        "content": "<strong>[4] </strong><strong style=\"color: rgb(112, 48, 160);\"><em>国家自然科学基金面上项目</em></strong><span style=\"color: black;\"> （62272339）：面向无线信道状态信息的智能感知与行为识别鲁棒性研究，2023-2026，53万元</span>，<strong><u>负责人</u></strong>。",
        "id": 10,
        "language": "汉语"
    },
    {
        "content": "<strong>[5] </strong><strong style=\"color: rgb(112, 48, 160);\"><em>工信部重点项目</em></strong> ：工业互联网创新发展工程-时间敏感网络控制系统项目，2021-2023，90万元，<strong><u>负责人</u></strong>。",
        "id": 11,
        "language": "汉语"
    }
];

export default data;
